import { useQuery } from '@tanstack/react-query';
import type { ContestType } from '@betterpool/api-types/contests-service';

import { getLocationSettings } from '~/services/contests/contests.service.api';
import { ContestQueryKeys, STALE_TIME } from '~/domains/contest/constants/query';

export function useContestLocationSettings(): {
  allowedTagNames: ContestType[] | undefined;
};
export function useContestLocationSettings(params: { enabled?: boolean; staleTime?: number }): {
  allowedTagNames: ContestType[] | undefined;
};

export function useContestLocationSettings(params?: { enabled?: boolean; staleTime?: number }) {
  const { enabled, staleTime = STALE_TIME } = params || {};

  const data = useQuery(ContestQueryKeys.CONTEST_LOCATION_SETTINGS(), () => getLocationSettings(), {
    enabled,
    staleTime,
  });

  return {
    allowedTagNames: data.data?.allowedTagNames,
  };
}
